
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/platform/email-capture",
      function () {
        return require("private-next-pages/platform/email-capture/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/platform/email-capture"])
      });
    }
  